/** Names of system properties for info videos */
export enum InfoVideoName {
  CONTACTS_SCREEN = 'info_video_contacts_drive_id',
  GOALS_SCREEN = 'info_video_goals_screen_drive_id',
  CHECKLIST_SCREEN = 'info_video_checklist_screen_drive_id',
  MEALS_SCREEN = 'info_video_meals_screen_drive_id',
  CALENDAR_SCREEN = 'info_video_calendar_screen_drive_id',
}
